import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

export const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' }) : '-';

export const formatTime = (date) =>
    date ? new Date(date).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }) : '-';

export const handleFileDownload = (link) => {
    if (isEmpty(link)) {
        toast.warning('Download link not available');
        return;
    }

    window.location.href = link;
};

/**
 * Extracts error message from various error formats
 * @param {Error|string|object} error - The error object or string
 * @param {string} defaultMessage - Default message if error cannot be extracted
 * @returns {string} The extracted error message
 */
export const extractErrorMessage = (error, defaultMessage = 'An error occurred') => {
    if (typeof error === 'string') return error;
    
    return (
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        error?.message ||
        defaultMessage
    );
};
